import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { AllProductLines } from 'self-service-api/constants/ProductLines';
import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import { GYPSUM, OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { borderStyle } from '../free-tools-page/FreeToolsSharedComponents';
import { SectionTitle } from '../common/SharedComponents';
import MobileProductLineTile from './MobileProductLineTile';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import UITileSection from 'UIComponents/tile/UITileSection';
const MobileWhyGoHubSpotContainer = styled(UITile).withConfig({
  displayName: "MobileWhyGoHubSpotSection__MobileWhyGoHubSpotContainer",
  componentId: "sc-2o8tht-0"
})(["background-color:", ";border:none;padding:20px 0 60px;margin:20px 0;"], GYPSUM);
const MobileWhyGoHubSpotWrapper = styled(UITileSection).withConfig({
  displayName: "MobileWhyGoHubSpotSection__MobileWhyGoHubSpotWrapper",
  componentId: "sc-2o8tht-1"
})(["width:100%;padding:0;margin:0 auto;", ";"], breakpoint.tabletPortrait(_t || (_t = _`
    width: 94% !important;
  `)));
const TitleSection = styled.div.withConfig({
  displayName: "MobileWhyGoHubSpotSection__TitleSection",
  componentId: "sc-2o8tht-2"
})(["max-width:850px;margin:20px auto;text-align:center;"]);

const MobileWhyGoHubSpotSection = ({
  selectedNavItem
}) => {
  const productLineTileComponents = AllProductLines.map((productLine, index) => {
    const commonStyles = {
      gridColumnStart: index + 1,
      borderRight: borderStyle,
      borderLeft: borderStyle,
      backgroundColor: OLAF,
      width: '100%',
      textAlign: 'center',
      padding: '15px'
    };
    return /*#__PURE__*/_jsx(MobileProductLineTile, {
      commonStyles: commonStyles,
      productLine: productLine
    }, productLine);
  });
  return /*#__PURE__*/_jsx(MobileWhyGoHubSpotContainer, {
    children: /*#__PURE__*/_jsxs(MobileWhyGoHubSpotWrapper, {
      children: [/*#__PURE__*/_jsxs(TitleSection, {
        children: [/*#__PURE__*/_jsx(SectionTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `whyGoHubSpot.${selectedNavItem}.title`
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `whyGoHubSpot.${selectedNavItem}.subtitle`
          })
        })]
      }), productLineTileComponents]
    })
  });
};

export default MobileWhyGoHubSpotSection;